<template>
    <Modal
        ref="modal"
        class="lightbox"
        :class="{
            zoomable: isZoomable,
            zoomed: isZoomed
        }"
        teleport
        @open="$emit('open')"
        @close="$emit('close')"
    >
        <template #lightbox>
            <div
                class="lightbox-modal"
                @click="close"
            >
                <div
                    ref="container"
                    class="lightbox-container"
                    :style="{
                        height: isZoomed ? '100%' : `${dimensions.naturalHeight}px`,
                        width: isZoomed ? '100%' : `${dimensions.naturalWidth}px`,
                    }"
                >
                    <slot>
                        <img
                            class="lightbox-image"
                            :src="src"
                            :alt="alt || ''"
                            @load="updateImageOffset"
                            @click.stop="toggleZoom"
                        />
                    </slot>
                </div>
                <Btn
                    variant="media"
                    icon="cross"
                    class="close solid"
                    :icon-label="$trans('close')"
                    @click="close"
                />
            </div>
        </template>
    </Modal>
</template>

<script>
import { nextTick } from 'vue';
import { useResponsive } from '@/store/responsive';

import Btn from '@/components/utility/button';
import Modal from '@/components/utility/modal';

export default {
    name: 'Lightbox',
    components: { Modal, Btn },
    props: {
        src: { type: String, default: '' },
        alt: { type: String, default: '' },
        dimensions: { type: Object, default: () => ({}) }
    },
    emits: ['open', 'close'],
    data() {
        return {
            isZoomed: false,
            percentageY: 0,
            percentageX: 0,
            timer: 0,
            imageTop: 0,
            imageLeft: 0,
            imageWidth: 0,
            imageHeight: 0,
            viewport: useResponsive()
        };
    },
    computed: {
        isZoomable() {
            return this.dimensions.naturalHeight > this.viewport.height || this.dimensions.naturalWidth > this.viewport.width;
        }
    },
    methods: {
        close() {
            this.$refs.modal.close();
        },
        toggleZoom({ clientX, clientY }) {
            if (!this.isZoomable) return;
            this.isZoomed = !this.isZoomed;
            if (!this.isZoomed) return;

            this.percentageY = (clientY - this.imageTop) / this.imageHeight;
            this.percentageX = (clientX - this.imageLeft) / this.imageWidth;

            nextTick(() => {
                this.$refs.container.scrollTop = (this.dimensions.naturalHeight * this.percentageY) - (this.viewport.height / 2);
                this.$refs.container.scrollLeft = (this.dimensions.naturalWidth * this.percentageX) - (this.viewport.width / 2);
            });
        },
        updateImageOffset({ target }) {
            const { top, left, width, height } = target.getBoundingClientRect();
            this.imageTop = top;
            this.imageLeft = left;
            this.imageWidth = width;
            this.imageHeight = height;
        }
    }
};
</script>

<style lang="less">

.lightbox {
    &-modal {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        > .cobutton.close {
            position: absolute;
            top: 24px;
            right: 24px;
            background-color: ~"rgba(var(--coal-rgb), 0.9)";
            opacity: 1;
        }
    }
    &.zoomable .lightbox-image { cursor: zoom-in; }
    &.zoomed {
        .lightbox-container {
            display: grid;
            justify-content: unset;
            place-items: center;
        }
        .lightbox-image {
            cursor: zoom-out;
            max-width: none;
            max-height: none;
        }
    }
    &-container {
        max-height: 100vh;
        max-width: 100vw;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: auto;
    }
    &-image {
        max-width: 100%;
        max-height: 100%;
    }
    .oembed {
        aspect-ratio: 16 / 9;
        width: 95vw;
        max-width: 900px;
        border-radius: 16px;
    }
}
</style>
